import { NKDatetimeModule } from 'ng2-datetime/ng2-datetime';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { WindowRef } from '../../../../classes/windowRef';
import { DOCUMENT } from '@angular/platform-browser';
import * as $ from 'jquery';

@Component({
  selector: 'dashboard-referrer',
  templateUrl: './dashboard-referrer.component.html',
  styleUrls: ['./dashboard-referrer.component.scss']
})
export class DashboardReferrerComponent implements OnInit {
  @ViewChild( 'scrolledTable' ) scrolledTable;
  @ViewChild( 'fixedTable' ) fixedTable;
  @ViewChild( 'tableWrapper' ) tableWrapper;

	sortingData = {
		field: 			'updated_at',
		direction:  'DESC'
  };

  all_sales: string = '0.00';
  all_profit: string = '0.00';
  referred_projects: number = 0;
  referrer_comission: string = '0.00';
  projected_comission: string = '0.00';
  project_completed = 0;

  scrolledTableOffsetTop = 0;

  clients: any[] = [];
  salespersons: any[] = [];
  projects: any[] = [];

  isDisabledFilters: boolean = false;
  visibleScrolledTable: boolean = false;

  paginationData = {
  	count: 30,
  	offset: 0,
  	count_all: 0,
  	currentPage: 1,
  	maxPage: 1
  };

  filtersData = {
    client: '',
  	Name: '',
  	ProductCost: '',
    status: '',
    sales: '',
    invoice: '',
    proposal: '',
    jobType: '',
    comission_paid: '',
    BuildingType: '',
    dueTotal: '',
    referrerAmount: '',
    fromDate: undefined,
    toDate: undefined
  };

	projectsData = [];
  projectStatuses = {
    newLead: 'New lead',
    leadLost: 'Lead lost',
    pendingManagerApproval: 'Pending manager approval',
    managerApproved: 'Manager approved',
    proposalSent: 'Proposal sent',
    invoiceSent: 'Invoice sent',
    purchaseOrderSent: 'Purchase order sent',
    productsShipped: 'Products shipped',
    productsReceived: 'Products received',
    depositReceived: 'Deposit received',
    installationPending: 'Installation pending',
    installationCompleted: 'Installation completed',
    paidInFull: 'Paid in full',
    projectCompleted: 'Project completed',
    projectCompletedRMARGA: 'Project completed with RMA/RGA',
    projectCancelled: 'Project cancelled',
    other: 'Other'
  };


  filtersTimeout: any;

	contentVisible: boolean = false;

  availableRoles: string[] = [ 'referrer', 'sales', 'manager' ];
  isAvailable: boolean = true;

  datepickerFromOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: 'from'
  };
  datepickerToOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: 'to'
  };

  _date_from: any = '';
  _date_to: any = '';
  _old_from: any = ''
  _old_to: any = '';
  _was_matched_from: boolean = false;
  _was_matched_to: boolean = false;

  _scrollTop:number = 0;
  _scrollTopTimer:any = null;
  _scrollSystemInit: boolean = false;


  projectJobTypes = {
    repair: "Repair",
    retrofit: "Retrofit",
    newInstall: "Non-retrofit"
  };

  projectBuildingTypes = {
    bank: "Bank",
    commercialBuilding: "Commercial building",
    educationalInstitution: "Educational institution",
    hospitality: "Hospitality",
    hospitalHealthcare: "Hospital / Healthcare",
    massTransit: "Mass transit",
    parkingLot: "Parking lot",
    residentialBuilding: "Residential building",
    restaurant: "Restaurant",
    retailStore: "Retail store",
    supermarket: "Supermarket",
    warehouse: "Warehouse",
    other: "Other"
  };


  selectWidth: number = 160;

  reloadInterval: any;

  selectParams: any = {

    client: {
      id: 'selectClient',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.client = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },

    sales: {
      id: 'selectSales',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.sales = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },
    
    jobType: {
      id: 'selectJobType',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.jobType = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Repair', value: 'repair' },
        { text: 'Retrofit', value: 'retrofit' },
        { text: 'Non-retrofit', value: 'newInstall' }
      ]
    },

    comissionPaid: {
      id: 'selectCommissionPaid',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.comission_paid = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Yes', value: 'true' },
        { text: 'No', value: 'false' }
      ]
    },

    buildingType: {
      id: 'selectBuildingType',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.BuildingType = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Bank', value: 'bank' },
        { text: 'Commercial building', value: 'commercialBuilding' },
        { text: 'Educational institution', value: 'educationalInstitution' },
        { text: 'Hospitality', value: 'hospitality' },
        { text: 'Hospital / Healthcare', value: 'hospitalHealthcare' },
        { text: 'Mass transit', value: 'massTransit' },
        { text: 'Parking lot', value: 'parkingLot' },
        { text: 'Residential building', value: 'residentialBuilding' },
        { text: 'Restaurant', value: 'restaurant' },
        { text: 'Retail store', value: 'retailStore' },
        { text: 'Supermarket', value: 'supermarket' },
        { text: 'Warehouse', value: 'warehouse' },
        { text: 'Other', value: 'other' }
      ]
    },
    
    name: {
      id: 'selectName',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.Name = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },

    status: {
      id: 'selectStatus',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.status = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { value: "newLead", text: 'New lead' },
        { value: "leadLost", text: 'Lead lost' },
        { value: "pendingManagerApproval", text: 'Pending manager approval' },
        { value: "managerApproved", text: 'Manager approved' },
        { value: "proposalSent", text: 'Proposal sent' },
        { value: "depositReceived", text: 'Deposit received' },
        { value: "invoiceSent", text: 'Invoice sent' },
        { value: "purchaseOrderSent", text: 'Purchase order sent' },
        { value: "productsShipped", text: 'Products shipped' },
        { value: "productsReceived", text: 'Products received' },
        { value: "paidInFull", text: 'Paid in full' },
        { value: "installationPending", text: 'Installation pending' },
        { value: "installationCompleted", text: 'Installation completed' },
        { value: 'projectCompleted', text: 'Project completed' },
        { value: 'projectCompletedRMARGA', text: 'Project completed with RMA/RGA' },
        { value: 'projectCancelled', text: 'Project cancelled' },
        { value: "other", text: 'Other' }
      ]
    }
  };


  constructor ( 
    @Inject(DOCUMENT) private document: Document,
    private model: ModelService,
    private winRef: WindowRef,
    private global: GlobalService,
    public loginService: LoginService ) {
    this.global.setDocumentTitle( 'Dashboard' ); 
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  
  ngOnInit( ) {
    this.reloadInterval = setInterval( ( ) => {
      this.loadData( );
    }, 1000 * 2 * 60 ); // 2 minutes interval

    // this.model.getUsersData( ( usersData ) => {
    //   usersData = usersData.json( );
    //   this.admins = usersData.users;
    // }, { role: 'admin', status: 'active', not_empty_name: 'true' });
    

    this.model.getClientsData( ( clientsData ) => {
      this.clients = clientsData;
      clientsData.forEach( _cl => { this.selectParams.client.options.push( { text: _cl.FirstName + ' ' + _cl.LastName, value: _cl.id } ); });
    }, 'Company' );

    this.model.getProjectsListData( ( prData ) => {
      prData = prData.json( );
      this.projects = prData.projects;
      prData.projects.forEach( _pr => { this.selectParams.name.options.push( { text: _pr.Name, value: _pr.id } ); });
    });

    this.model.getUsersData( ( usersData ) => {
      usersData = usersData.json( );
      this.salespersons = usersData.users;
      usersData.users.forEach( _sp => { 
        this.selectParams.sales.options.push( { text: _sp.firstName + ' ' + _sp.secondName, value: _sp.id } ); 
      });
    }, { status: 'active', not_empty_name: 'true' });

    // this.model.getProjectsListData( ( prData ) => {
    //   prData = prData.json( );
    //   this.projects = prData.projects;
    //   prData.projects.forEach( _pr => { this.selectParams.name.options.push( { text: _pr.Name, value: _pr.id } ); });
    // });

  }

  _scrollIntoView ( ) {
    // Code to scroll window
    setTimeout( ( ) => {
      this.winRef.nativeWindow.scrollTo( 0, this._scrollTop );
    }, 1500 );
  }

  ngAfterViewInit ( ) {
    let _sorting = localStorage.getItem( 'sortingReferrerDashboard' );
    let _filters = localStorage.getItem( 'filtersReferrerDashboard' );
    let _pagination = localStorage.getItem( 'paginationReferrerDashboard' );
    let _scroll = localStorage.getItem( 'scrollReferrerDashboard' );
    if ( _sorting ) this.sortingData = JSON.parse( _sorting );
    if ( _filters ) this.filtersData = JSON.parse( _filters );
    if ( _pagination ) this.paginationData = JSON.parse( _pagination );
    if ( _scroll ) this._scrollTop = +_scroll;
    if ( this.filtersData.fromDate || this.filtersData.fromDate === '' ) this._date_from = this.global.parseDate( this.filtersData.fromDate );
    if ( this.filtersData.toDate || this.filtersData.toDate === '' ) this._date_to = this.global.parseDate( this.filtersData.toDate );
    this.loadData( null, this._scrollIntoView( ) );
  }

  onScrollDocument ( event ) {

    clearTimeout( this._scrollTopTimer );
    this._scrollTopTimer = setTimeout( ( ) => {
      if ( this._scrollSystemInit || this._scrollTop != 0 ) {
        localStorage.setItem( 'scrollReferrerDashboard', this.winRef.nativeWindow.scrollY );
      } else {
        this._scrollSystemInit = true;
      }
    }, 350);

    let headerHeight = 71;
    let _wrapper = this.document.getElementsByClassName('scrolled-table--wrapper')[0];

    // Fixing of header height
    if ( this.global.displayWidth < 768 ) headerHeight = 51;

    if ( this.fixedTable && this.tableWrapper ) {
      if ( event.target.scrollingElement.scrollTop > headerHeight + this.tableWrapper.nativeElement.offsetTop ) {
        this.visibleScrolledTable = true;
        if ( _wrapper ) _wrapper.scrollLeft = this.tableWrapper.nativeElement.scrollLeft;
      } else {
        this.visibleScrolledTable = false;
      }
    } else {
      this.visibleScrolledTable = false;
    }
    
  }

  onHorizontalScroll ( event ) {

    if ( this.scrolledTable && this.fixedTable && this.tableWrapper ) {
      this.document.getElementsByClassName('scrolled-table--wrapper')[0].scrollLeft = this.tableWrapper.nativeElement.scrollLeft;
    }

  }

  projectRedirect ( id ) {
  	this.global.redirect( '/project-detail/'+id );
  }

  changeSorting ( _sortField ) {

  	if ( _sortField != this.sortingData.field ) {
  		this.sortingData.field = _sortField;
  		this.sortingData.direction = 'ASC';
  	} else {
  		this.sortingData.direction = ( this.sortingData.direction == 'ASC' ) ? 'DESC' : 'ASC';
  	}

    this.paginationData.offset = 0;
    this.paginationData.currentPage = 1;

    localStorage.setItem( 'sortingReferrerDashboard', JSON.stringify( this.sortingData ) );
    localStorage.setItem( 'paginationReferrerDashboard', JSON.stringify( this.paginationData ) );

  	this.loadData( );

  }

  changeFilters ( clearing?:boolean ) {

    clearTimeout( this.filtersTimeout );
    this.filtersTimeout = setTimeout( ( ) => {
      this.paginationData.offset = 0;
      this.paginationData.currentPage = 1;
      if ( clearing !== true ) {
        localStorage.setItem( 'filtersReferrerDashboard', JSON.stringify( this.filtersData ) );
        localStorage.setItem( 'paginationReferrerDashboard', JSON.stringify( this.paginationData ) );
      } else {
        localStorage.removeItem( 'sortingReferrerDashboard' );
        localStorage.removeItem( 'filtersReferrerDashboard' );
        localStorage.removeItem( 'paginationReferrerDashboard' );
      }
      // this.isDisabledFilters = true;
      if ( clearing == true ) this.loadData( false );
      else this.loadData( );
    }, 350 );

  }

  clearFilters ( ) {
    this.filtersData = {
      client: '',
    	Name: '',
      ProductCost: '',
    	status: '',
      sales: '',
      invoice: '',
      proposal: '',
      jobType: '',
      comission_paid: '',
      BuildingType: '',
      dueTotal: '',
      referrerAmount: '',
      fromDate: '',
      toDate: ''
    };
    this._date_from = '';
    this._date_to = '';
    this.sortingData = {
      field:       'updated_at',
      direction:   'DESC'
    };
    this.changeFilters( true );
  }

  changePage ( page ) {
  	this.paginationData.currentPage = page;
  	this.paginationData.offset = (page-1) * this.paginationData.count;
    localStorage.setItem( 'paginationReferrerDashboard', JSON.stringify( this.paginationData ) );
  	this.loadData( false );
    $('html,body').animate({ scrollTop: 0 }, 'slow');
  }

  handleDateFromChange ( $event ) {
    if ( $event === undefined ) return;
    let _date = ( $event.getMonth( ) + 1 ) + '/' + $event.getDate( ) + '/' + $event.getFullYear( );

    this.filtersData.fromDate = _date;
    this._old_from = _date;
    this._was_matched_from = true;
    this.changeFilters( );
  }
  handleDateToChange ( $event ) {
    if ( $event === undefined ) return;
    let _date = ( $event.getMonth( ) + 1 ) + '/' + $event.getDate( ) + '/' + $event.getFullYear( );

    this.filtersData.toDate = _date;
    this._old_to = _date;
    this._was_matched_to = true;
    this.changeFilters( );
  }

  changeDatePickerFrom ( _value, _ref ) {
    if ( _value === undefined ) return;
    _ref.filtersData.fromDate = '';
    
    if ( _value.match( /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/ ) ) {
      if ( _value != _ref._old_from ) {
        _ref._old_from = _value;
        _ref._was_matched_from = true;
        _ref.filtersData.fromDate = _value;
        _ref.changeFilters( );
      }
    } else {
      if ( _ref._was_matched_from == true ) {
        _ref._old_from = _value;
        _ref._was_matched_from = false;
        _ref.changeFilters( );
      }
    }
  }
  changeDatePickerTo ( _value, _ref ) {
    if ( _value === undefined ) return;

    _ref.filtersData.toDate = '';
    
    if ( _value.match( /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/ ) ) {
      if ( _value != _ref._old_to ) {
        _ref._old_to = _value;
        _ref._was_matched_to = true;
        _ref.filtersData.toDate = _value;
        _ref.changeFilters( );
      }
    } else {
      if ( _ref._was_matched_to == true ) {
        _ref._old_to = _value;
        _ref._was_matched_to = false;
        _ref.changeFilters( );
      }
    }
  }

  loadData ( _withoutPreloader?, cb? ) {
  	let requestData = {};
    let withoutPreloader = true;
    if ( _withoutPreloader === false ) withoutPreloader = false;

  	requestData['sorting'] = this.sortingData;
  	requestData['pagination'] = this.paginationData;
  	requestData['filters'] = this.filtersData;
    
    this.model.getAdminDashboardData( requestData, ( response ) => {
      // this.isDisabledFilters = false;
      this.contentVisible = true;
      // this.checkEqualityFilters( response.filters );
      this.projectsData = response.data;
      this.sortingData = response.sorting;
      this.paginationData = response.pagination;
      this.filtersData = response.filters;
      this.all_sales = response.AllProductCost;
      this.all_profit = response.all_profit;
      this.referred_projects = response.referred_projects;
      this.referrer_comission = response.referrer_comission;
      this.projected_comission = response.projected_comission;
      this.project_completed = response.project_completed;
      if ( cb ) cb( );
  	}, withoutPreloader);
  }

  // checkEqualityFilters ( filters ) {

  //   let isEqual = true;

  //   for ( let item in filters ) {
  //     if ( this.filtersData[item] != filters[item] ) {
  //       isEqual = false;
  //       break;
  //     }
  //   }

  //   if ( !isEqual ) this.loadData( );

  // }

  ngOnDestroy( ) {
    clearInterval( this.reloadInterval );
  }
}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/dashboard-referrer/dashboard-referrer.component.ts